module.exports = __webpack_public_path__ + "img/E_SDG_Icons-10.e2d45a9f.jpg";